import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Form, Modal, ModalContext, Select, Text, toast } from "dash-ui";
import {
  BrandingTypeEnum,
  useUpdateMediaBrandingTypeMutation,
} from "gql/generated.graphql";
import { getBrandingTypeOptions } from "../../helpers/brandingTypeOptions";

function UpdateMediaBrandingModal() {
  const { t } = useTranslation(["common", "pages"]);
  const { isOpenCurrent, toggleModal, setPayload, payload } =
    useContext(ModalContext);
  const [updateMediaBrandingType, { loading }] =
    useUpdateMediaBrandingTypeMutation();

  const isOpen = !!isOpenCurrent["UpdateMediaBrandingModal"];
  const media = payload?.media;
  const currentBrandingType = media?.brandingType || BrandingTypeEnum.Unbranded;

  const [selectedBrandingType, setSelectedBrandingType] =
    useState(currentBrandingType);

  useEffect(() => {
    if (media) {
      setSelectedBrandingType(media.brandingType || BrandingTypeEnum.Unbranded);
    }
  }, [media]);

  const onModalClose = () => {
    toggleModal(false, "UpdateMediaBrandingModal");
    setPayload(null);
    setSelectedBrandingType(BrandingTypeEnum.Unbranded);
  };

  const handleSubmit = async () => {
    if (!media) return;

    try {
      await updateMediaBrandingType({
        variables: {
          mediaId: media._id,
          brandingType: selectedBrandingType,
        },
      });
      toast.success(t("pages:propertyPage.brandingTypeUpdated"));
      onModalClose();
    } catch (error) {
      console.error("Error updating media branding type:", error);
      toast.error(t("common:serverMessages.unknown"));
    }
  };

  const brandingOptions = getBrandingTypeOptions(t);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onModalClose}
      title={t("pages:propertyPage.updateBrandingTitle") || ""}
      submitButton={{
        title: t("common:labels.update"),
        isLoading: loading,
        disabled: loading || selectedBrandingType === currentBrandingType,
        onClick: handleSubmit,
      }}
      cancelButton={{
        title: t("common:labels.cancel"),
        onClick: onModalClose,
      }}
    >
      {media && (
        <Form>
          <Box mb={3}>
            <Text medium>
              {t("pages:propertyPage.currentFile") || ""}:{" "}
              {media.files?.[0]?.name || media.folderName}
            </Text>
          </Box>
          <Form.Group>
            <Form.Label>{t("common:labels.brandingType") || ""}</Form.Label>
            <Select
              w="100%"
              value={selectedBrandingType}
              onChanged={(value?: string) => {
                if (value) {
                  setSelectedBrandingType(value as BrandingTypeEnum);
                }
              }}
              options={brandingOptions}
              placeholder={t("common:placeholders.selectBrandingType") || ""}
              isSearchable={false}
            />
          </Form.Group>
        </Form>
      )}
    </Modal>
  );
}

export default UpdateMediaBrandingModal;
